// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"W2Why_wrapper__QKogr","top":"W2Why_top__zp__g","title":"W2Why_title__NCLyf","list":"W2Why_list__PyCFq","item":"W2Why_item__mqH9P","itemTitle":"W2Why_itemTitle__yYgfX"};